import { ReactNode } from 'react'
import styled from 'styled-components'

export enum PillVariants {
  error = 'error',
  warning = 'warning',
  info = 'info',
  success = 'success'
}

type PillProps = {
  variant?: PillVariants
  children: ReactNode
  className?: string
  style?: any
}

const cssPerVariantProp: { [T: string]: string } = {
  info: `
    background-color: #f6f6f6;
    color: #4b4b4b;
  `,
  success: `
    background-color: #e6f6f2;
    color: #007e5f;
  `,
  error: `
    background-color: #fde6f0;
    color: #a82b60;
  `,
  warning: `
    color: #423347;
    background-color: #e1d9f2;
  `
}

const StyledPill: any = styled.div`
  padding: 6px 16px;
  font-size: 0.75rem;
  display: inline-block;
  font-weight: bold;
  border-radius: 2rem;
  min-width: 90px;
  text-align: center;

  ${({ variant = 'info' }: { variant: string }) => cssPerVariantProp[variant]};
`

const Pill = ({ variant = PillVariants.info, children, className, style }: PillProps) => {
  return (
    <StyledPill variant={variant} className={className} style={style}>
      {children}
    </StyledPill>
  )
}

Pill.displayName = 'Pill'

export default Pill
